export const REMITTANCE_SIGNUP = "remittance";
